/* eslint-disable react/jsx-props-no-spreading */
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { useGetAllByUser } from 'utils/hooks/organizations';
import { useGetAllPrograms } from 'utils/hooks/programs';
import {
  ProjectStackBarChart,
  ProjectChartRound,
  ProjectProposalPieChart,
  ProjectVerticalBar,
  ProjectExpenditureChart,
  ProjectChartVerticalBar,
  ProjectProposalChartVerticalBar,
} from './components';

export default function Dashboard() {
  const { t } = useTranslation();
  const { data: organizations } = useGetAllByUser(t, {});
  const { data: programs } = useGetAllPrograms({});

  const filterData = useMemo(
    () => ({
      organizations: organizations || [],
      programs: programs || [],
    }),
    [organizations, programs]
  );

  return (
    <div>
      <div className="grid">
        <div className="col-12 md:col-6">
          <ProjectProposalPieChart {...filterData} />
        </div>
        <div className="col-12 md:col-6">
          <ProjectProposalChartVerticalBar {...filterData} />
        </div>
        <div className="col-12 md:col-6">
          <ProjectChartRound {...filterData} />
        </div>
        <div className="col-12 md:col-6">
          <ProjectChartVerticalBar {...filterData} />
        </div>
        <div className="col-12">
          <ProjectStackBarChart {...filterData} />
        </div>
        <div className="col-12">
          <ProjectVerticalBar {...filterData} />
        </div>
        <div className="col-12">
          <ProjectExpenditureChart {...filterData} />
        </div>
      </div>
    </div>
  );
}
